import React, { useState } from 'react';
import { Text, Tooltip } from '@chakra-ui/react';

/**
 * ShortenedText component - Displays text with a maximum length, showing full text on hover
 * @param {string} text - The text to display
 * @param {number} maxLength - Maximum length before truncating (default: 50)
 * @param {object} props - Additional props to pass to the Text component
 */
const ShortenedText = ({ text, maxLength = 50, ...props }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  if (!text) return null;
  
  const shouldTruncate = text.length > maxLength;
  const displayText = shouldTruncate ? `${text.substring(0, maxLength)}...` : text;
  
  return shouldTruncate ? (
    <Tooltip label={text} placement="top" hasArrow bg="gray.700" color="white">
      <Text 
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        cursor="pointer"
        textDecoration={isHovered ? 'underline' : 'none'}
        transition="text-decoration 0.2s"
        {...props}
      >
        {displayText}
      </Text>
    </Tooltip>
  ) : (
    <Text {...props}>{text}</Text>
  );
};

export default ShortenedText;
